import { Injectable } from '@angular/core';

import { INVESTIGATOR_ROUTES_FEATURE_FLAGS } from '@shared/constants/feature-flags-guards/investigator-feature-flags.const';
import { ROUTING_PATH } from '@shared/constants/routingPath';
import { BasicRedirectToNextTabGuard } from '@shared/guards/basic-redirect-to-next-tab.guard';
import { Flags } from '@shared/services/launch-darkly.service';

@Injectable({
  providedIn: 'root',
})
export class InvestigatorSettingsGuard extends BasicRedirectToNextTabGuard {
  protected prefix = `/${ROUTING_PATH.INVESTIGATOR.INDEX}`;
  protected defaultNavigateUrl = `/${this.prefix}/${ROUTING_PATH.INVESTIGATOR.SITE_COSTS.INDEX}`;
  protected featureFlag = 'investigator_forecast_settings' as keyof Flags;
  protected routerPathsAndFeatureFlags = INVESTIGATOR_ROUTES_FEATURE_FLAGS;
}
